module.exports = __webpack_public_path__ + "img/tanzania.12916cf4.svg";